import { ReactComponent as UserSvg } from '../images/icons/user.svg';
import { ReactComponent as BulbSvg } from '../images/icons/bulb.svg';
import { ReactComponent as SeedSvg } from '../images/icons/seed.svg';
import { ReactComponent as RocketSvg } from '../images/icons/rocket.svg';
import { ReactComponent as MugSvg } from '../images/icons/mug.svg';
import { ReactComponent as UserPlusSvg } from '../images/icons/userPlus.svg';
import Background from './Background';
import AnimatedComponent from './AnimatedComponent';
import CountUp from 'react-countup';

function About() {
  return (
    <section id='about'>
      <div className='container'>
        <div className='content'>
          <h1 className='sectionHeader'>About me</h1>
          <AnimatedComponent>
            <div className='glass'>
              <div className='glassItem'>
                <UserSvg />
                <p className='text'>
                  Front-End Developer with over two years of experience
                  specializing in the MERN stack. Focused on building
                  responsive, scalable applications and delivering clean,
                  user-centered solutions in agile environments.
                </p>
              </div>
              <div className='glassItem'>
                <BulbSvg />
                <p className='text'>
                  I love turning ideas into user-friendly interfaces and solving
                  challenges to deliver quality solutions. Besides front-end
                  development, I excel at using data structures and algorithms
                  to make my code efficient and perform well.
                </p>
              </div>
              <div className='glassItem'>
                <SeedSvg />
                <p className='text'>
                  Currently, I'm expanding my skill set by diving deeper into
                  Node.js and honing my JavaScript skills to become a
                  well-rounded full-stack developer.
                </p>
              </div>
              <div className='glassItem'>
                <RocketSvg />
                <p className='text'>
                  Whether it's building responsive websites, developing
                  interactive web applications, or exploring new technologies,
                  I'm dedicated to pushing the boundaries of what's possible in
                  web development.
                </p>
              </div>
              <div className='glassItem'>
                <MugSvg />
                <p className='text'>
                  When I'm not coding or teaching, you can find me exploring the
                  latest trends in web design, working on personal projects, or
                  contributing to open-source initiatives.
                </p>
              </div>
              <div className='glassItem'>
                <UserPlusSvg />
                <p className='text'>
                  Let's connect and collaborate on exciting projects together!
                </p>
              </div>
            </div>
          </AnimatedComponent>
          <div className='counters'>
            <AnimatedComponent>
              <div className='counterItem'>
                <h1 className='count'>
                  <CountUp end={2} duration={3} enableScrollSpy />+
                </h1>
                <p className='label'>Years of experience</p>
              </div>
            </AnimatedComponent>
            <div className='counterSplitter'></div>
            <AnimatedComponent>
              <div className='counterItem'>
                <h1 className='count'>
                  <CountUp end={2} duration={3} enableScrollSpy />
                </h1>
                <p className='label'>Completed Projects</p>
              </div>
            </AnimatedComponent>
            <div className='counterSplitter'></div>
            <AnimatedComponent>
              <div className='counterItem'>
                <h1 className='count'>
                  <CountUp end={0} duration={3} enableScrollSpy />
                </h1>
                <p className='label'>Customers</p>
              </div>
            </AnimatedComponent>
          </div>
          <div className='background'>
            <div className='educations'>
              <AnimatedComponent>
                <h2 className='educationsHeader'>Education</h2>
              </AnimatedComponent>
              <AnimatedComponent>
                <Background
                  label='Code Academy'
                  data={[
                    {
                      name: 'Software Development',
                      start: '10/2021',
                      end: '02/2022',
                    },
                  ]}
                />
              </AnimatedComponent>
              <AnimatedComponent>
                <Background
                  label='Azerbaijan Technical University | Bachelor'
                  data={[
                    {
                      name: 'Information Technologies Engineering',
                      start: '09/2018',
                      end: '07/2022',
                    },
                  ]}
                />
              </AnimatedComponent>
            </div>
            <div className='experiences'>
              <AnimatedComponent>
                <h2 className='experiencesHeader'>Work Experience</h2>
              </AnimatedComponent>
              <AnimatedComponent>
                <Background
                  label='Andersen Lab'
                  data={[
                    {
                      name: 'Javascript Developer',
                      start: '06/2025',
                      end: 'present',
                    },
                  ]}
                />
              </AnimatedComponent>
              <AnimatedComponent>
                <Background
                  label='Algo Academy'
                  data={[
                    {
                      name: 'Front-End Instructor',
                      start: '10/2023',
                      end: '07/2024',
                    },
                  ]}
                />
              </AnimatedComponent>
              <AnimatedComponent>
                <Background
                  label='Qmeter'
                  data={[
                    {
                      name: 'Front-End Developer',
                      start: '06/2021',
                      end: '06/2022',
                    },
                    // {
                    //   name: 'Front-end developer (intern)',
                    //   start: '06/2021',
                    //   end: '09/2021',
                    // },
                  ]}
                />
              </AnimatedComponent>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
